import { PageState } from 'models/PageState';
import { BasePageModel } from 'models/BasePageModel';

const cleanViews: string[] = ['CheckoutPage', 'PpiPage'];

export const isCleanView = (state: PageState) =>
  cleanViews.includes(state.currentPage.componentName);

export const getPageTopContentArea = (currentPage: BasePageModel) => {
  return currentPage.pageTopContentArea;
};
